export default class Constants {
    public static DraftId = -1;
    public static ApprovementId = -2;
}
